import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { CAS_MARK, CAS_MARKS } from "./casMark";

// Cas's mark: whichever mark casMark.ts selects (CAS_MARK, U.10), in dark ink
// on the magenta disc. Rendered as an <img> so the SVG's clipPath id never
// collides when the logo appears more than once.

export interface CasLogoProps {
  size?: number;
  sx?: SxProps<Theme>;
  "data-testid"?: string;
}

export const CasLogo: React.FC<CasLogoProps> = ({ size = 24, sx, "data-testid": testId = "cas-logo" }) => (
  <Box
    component="img"
    src={CAS_MARKS[CAS_MARK]}
    alt="Cas"
    data-testid={testId}
    data-mark={CAS_MARK}
    draggable={false}
    sx={[
      { width: size, height: size, display: "block", flexShrink: 0 },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);
